import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextIndentRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-indent-right"><path d="M21.25 14V10L18.25 12L21.25 14Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.25 5.75H2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.25 18.25H2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.25 12H2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.5 12L20.5 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTextIndentRight;
